<footer class=" bg-neutral py-10 w-full">
  <div class="container mx-auto px-4 lg:px-0">
    <div class="text-neutral-content grid-flow-row footer">
  <div class="footer-top">
    Contact Us
    <p>FAYA Corporation<br />
      Email on <a href="mailto:info@fayausa.com"></a>info&#64;fayausa.com <br />
      Call - <a href="tel:866-686-5988">866-686-5988</a><br>
      Thejaswini, Technopark Campus, Thiruvananthapuram,
        Kerala,
        India
    </p>
  </div>
  <div class="footer-bottom w-full flex-col-reverse lg:flex-row flex justify-between items-center">
    <div class="copyright">
      <p class="copy-right-footer">Copyright ©
        <a href="http://fayausa.com">FAYA Corporation</a> {{year}}
      </p>
    </div>
    <nav>
      <div class="grid grid-flow-col place-items-center gap-4 text-xl">
        <ng-container *ngFor="let socialLink of socialLinks">
          <a href="{{socialLink.url}}" target="_blank" class="text-white">
            <i class="fab fa-{{socialLink.icon}}"></i>
          </a> 
        </ng-container>
      </div>
    </nav>
  </div>
</div>
</div>
</footer>
